export const BACKEND = 'https://amaraapi.herokuapp.com/api';
